/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
export const environment = {
  production: true,

  //baseUrl
  // baseUrl:'https://core.carefluence.com/cf.admin.core.stg/',
  // baseUrlNotDev: 'https://core.carefluence.com/cf.admin.core.stg/',

  //subUrl
  apiUrl: 'https://cfadmin2023.azurewebsites.net/dev/',
   fhiropsUrl: 'https://cfadmin2023.azurewebsites.net/fhirops.prod/'
  // fhiropsUrl: 'https://openapi-r4-fhirops.politegrass-a89d45ee.eastus.azurecontainerapps.io/'
};
